// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';

function useOnMount(callback) {
  useEffect(() => {
    callback();
  }, []);
}

export default useOnMount;
